/** returns a boolean representing if the current environment is dev or not
 *
 * @author Triston Armstrong
 */
export function isMock() {
  return process.env.REACT_APP_MOCK === 'true'
}
